import type { BranchPredicateConfig } from '@onefootprint/request-types/dashboard';

const getSupportedValues = (predicate: BranchPredicateConfig | null | undefined) =>
  predicate?.supportedValues ?? (predicate?.kind === 'bool' ? ['true', 'false'] : []);

export default getSupportedValues;
